import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  item_categories: [],
};

const getters = {
  allItemCategories: (state) => state.item_categories,
};

const actions = {
  async fetchItemCategories({ commit }, params = {}) {
    try {
      commit("resetItemCategories");
      const response = await axios.get("/item-category", { params: prm(params) });
      commit("setItemCategories", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch item_categories:", error);
    }
  },
  async createItemCategory({ commit }, item_category) {
    try {
      const response = await axios.post("/item-category", item_category);
      commit("addItemCategory", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create item_category:", error);
      throw error;
    }
  },
  async fetchItemCategoryById(_, id) {
    try {
      const response = await axios.get(`/item-category/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch item_category:", error);
      throw error;
    }
  },
  async updateItemCategory({ commit }, item_category) {
    try {
      const response = await axios.put(`/item-category/${item_category.id}`, item_category);
      commit("updateItemCategory", response.data);
    } catch (error) {
      console.error("Failed to update item_category:", error);
      throw error;
    }
  },
  async deleteItemCategoryById({ commit }, id) {
    try {
      const response = await axios.delete(`/item-category/${id}`);
      commit("removeItemCategory", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete item_category:", error);
      throw error;
    }
  },
};

const mutations = {
  setItemCategories(state, item_categories) {
    state.item_categories = item_categories.data; // Ensure this matches your API's response structure
  },
  addItemCategory(state, item_category) {
    state.item_categories.push(item_category);
  },
  updateItemCategory(state, updatedItemCategory) {
    const index = state.item_categories.findIndex(
      (item_category) => item_category.id === updatedItemCategory.id
    );
    if (index !== -1) {
      state.item_categories.splice(index, 1, updatedItemCategory);
    }
  },
  removeItemCategory(state, id) {
    state.item_categories = state.item_categories.filter(
      (item_category) => item_category.id !== id
    );
  },
  resetItemCategories(state) {
    state.item_categories = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
